import axios from "axios";
import QS from "qs";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);

// 环境的切换
const baseDev = `${window.location.protocol}//192.168.0.100:83`,
  basePro = `${window.location.protocol}//u.yuansiwei.com`;
axios.defaults.baseURL =
  process.env.NODE_ENV === "development" ? baseDev : basePro;
export default axios.defaults.baseURL;

// 请求超时时间
axios.defaults.timeout = 10000;

// header携带cookie
axios.defaults.withCredentials = true;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // showLoading();
    return config;
  },
  error => {
    return Promise.error(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // hideLoading();
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          // console.log(window.location.href);
          window.location.href =
            "https://f.yuansiwei.com/index.php?r=weixin/transferstation/evaluation&redirectUrl=" +
            window.location.href;
          // console.log("https://f.yuansiwei.com/index.php?r=weixin/transferstation/evaluation&redirectUrl=" +
          //   window.location.href);
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面

        case 403:
          // 清除token
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          break;
        // 404请求不存在
        case 404:
          break;
        // 其他错误，直接抛出错误提示
      }
      return Promise.reject(error.response);
    }
  }
);
//加载动画
// let LoadingCount = 0;
// const showLoading = () => {
//   if (LoadingCount === 0) {
//     Toast.loading({
//       message: "加载中...",
//       forbidClick: true
//     });
//   }
//   LoadingCount++;
// };
// const hideLoading = () => {
//   if (LoadingCount <= 0) return;
//   LoadingCount--;
//   if (LoadingCount === 0) {
//     Toast.clear;
//   }
// };
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}
